"use client";
import { formatDateToUnix, formatUnixToDate } from "@/utils/format.utils";
import { BoxProps, InputLabelProps } from "@mui/material";
import { DatePickerProps } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { ReactNode, memo } from "react";
import {
  Control,
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";
import AppDatePicker from "../AppDatePicker";
import AppTextField from "../AppTextField";
import AppFromLabelField from "./AppFromLabelField";
const AppFormControlDatePicker = <T extends FieldValues>({
  label,
  control,
  name,
  rules,
  controlProps,
  labelProps,
  datePickerProps,
  classNameContainer,
  onChangeValueForm,
  helper,
  childrenWrapperProps,
}: AppFormControlDatePickerProps<T>) => {
  return (
    <AppFromLabelField
      label={label}
      labelProps={{
        ...labelProps,
      }}
      className={classNameContainer}
      required={labelProps?.required}
      helper={helper}
      childrenWrapperProps={childrenWrapperProps}
    >
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { value, onChange, ...otherFieldProps },
          fieldState: { error: errorField },
        }) => (
          <AppDatePicker
            {...otherFieldProps}
            value={value ? dayjs(value) : null}
            onChange={(date) => {
              let valueDate: Date | null = null;
              if (date) {
                valueDate = new Date(
                  dayjs(date).year(),
                  dayjs(date).month(),
                  dayjs(date).date(),
                );
              }
              onChange(valueDate);
              if (onChangeValueForm && onChangeValueForm instanceof Function)
                onChangeValueForm(valueDate);
            }} // Convert to string
            slots={{
              textField: AppTextField,
            }}
            slotProps={{
              textField: {
                fullWidth: true,
                error: Boolean(errorField),
                helperText: errorField
                  ? errorField?.message
                    ? errorField?.message
                    : ""
                  : "",
              },
            }}
            {...datePickerProps}
          />
        )}
        {...controlProps}
      />
    </AppFromLabelField>
  );
};

type AppFormControlDatePickerProps<T extends FieldValues> = {
  label?: string | ReactNode;
  control: Control<any>;
  name: FieldPath<T>;
  rules?: RegisterOptions;
  controlProps?: Omit<ControllerProps, "render" | "name" | "control">;
  labelProps?: InputLabelProps;
  datePickerProps?: DatePickerProps<dayjs.Dayjs>;
  classNameContainer?: string;
  onChangeValueForm?: (value: Date | null) => void;
  helper?: string | ReactNode;
  childrenWrapperProps?: BoxProps;
};

export default memo(AppFormControlDatePicker);
